export default __webpack_public_path__ + "static/media/Nlogo.e29e49e1.svg";